import { FCAdditionalProps } from "@datassential/platform-ui-lib";
import cn from "classnames";
import Tabs from "@components/Tabs";
import { FC, useMemo, useState } from "react";
import { Metric } from "@core/models/Metric";
import Carousel from "@components/Carousel";
import { useProfileOtherItems } from "@core/api/useProfileOtherItems";
import ItemTile from "@vms/ItemTile";
import ContentHeader from "@components/ContentHeader";
import Title from "@components/Title";
import { ProfileDataResponseItem } from "@core/api/useProfileHeader";

const metricsTabsData = [
    { id: Metric.LoveIt, title: "Most Popular" },
    { id: Metric.KnowIt, title: "Fastest Growing" },
]

type OtherItemsProps = Omit<FCAdditionalProps, 'id'> & {
    id: ProfileDataResponseItem["id"];
}

const OtherItems: FC<OtherItemsProps> = ({
    id,
    className,
    testId,
    ...props
}) => {
    const [selectedView, setSelectedView] = useState<Metric>(Metric.LoveIt);

    const {
        data: otherItemsData,
	    isLoading,
    } = useProfileOtherItems(id);

    const slidesData = useMemo(() => {
        return (selectedView === Metric.LoveIt ? otherItemsData.mostPopular : otherItemsData.fastestGrowing) ?? [];
    }, [otherItemsData, selectedView]);

	const dummyItems = useMemo(() => Array(10).fill(null), [])

    const slides = useMemo(() => {
        return (isLoading ? dummyItems : slidesData).map((item, index) => ({
            id: item?.id ?? "",
            content: (
	            <ItemTile
		            item={item}
		            isLoading={isLoading}
		            testId={`blockItemTile${index}`}
	            />
            )
        }));
    }, [dummyItems, isLoading, slidesData]);

    return (
        <div
            className={cn(
                "ProfileOtherItems",
                className,
                "appears-top",
                "del-6",
            )}
            data-testid={testId}
            {...props}
        >
            <ContentHeader>
                <Title testId="textProfileOtherItemsTitle">OTHER FLAVORS IN THIS CATEGORY</Title>
                <Tabs
                    data={metricsTabsData}
                    modifiers={["height-l", "item-l"]}
                    activeTabId={selectedView}
                    onItemClick={setSelectedView}
                />
            </ContentHeader>
            <div
                className="ProfileOtherItems__tiles-container"
            >
                {slides.length ? (
                    <Carousel
                        slides={slides}
                        modifiers={["fluid"]}
                        testId="blockProfileOtherItemsSlides"
                        key={selectedView}
                    />
                ) : (
                    <div
                        className="ProfileOtherItems__no-items"
                        data-testid="textProfileOtherItemsNoData"
                    >
                        No items found
                    </div>
                )}
            </div>
        </div>
    );
};

export default OtherItems;